import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { LanguagesService } from "src/app/providers/languages.service";
import { SessionService } from "src/app/providers/session.service";

export enum ERROR_TYPE {
  NOT_VALID_PATIENT = 1,
  DEADLINE_EXPIRED = 2,
  ACCESS_DENIED = 3,
  NOT_VALID_PARAMS = 4,
  NOT_VALID_REQUEST = 5,
  EXPIRED_FILE = 6,
}

@Component({
  selector: "app-error-page",
  templateUrl: "./error-page.component.html",
  styleUrls: ["./error-page.component.scss"],
})
export class ErrorPageComponent {
  public isLoggedIn = this.sessionService.isLoggedIn();
  private readonly COOKIE_NOT_VALID_PATIENT = "redirect-notvalidpatient";
  private readonly COOKIE_DEADLINE_EXPIRED = "redirect-deadlineexpired";
  private readonly COOKIE_ACCESS_DENIED = "redirect-accessdenied";
  private readonly COOKIE_NOT_VALID_PARAMS = "redirect-invalidparams";
  private readonly COOKIE_NOT_VALID_REQUEST = "redirect-invalidrequest";
  private readonly COOKIE_EXPIRED_FILE = "redirect-expired-file";

  public message = "";

  constructor(
    private translateService: TranslateService,
    private cookieService: CookieService,
    private sessionService: SessionService,
    private languagesService: LanguagesService,
    private route: ActivatedRoute
  ) {
    this.translateService.use(this.languagesService.userLangOrBrowser).subscribe(() => {
      // Check for query param first
      const errorType = this.route.snapshot.queryParamMap.get("type");

      if (errorType) {
        this.message = this.getMessageByType(Number(errorType));
      } else {
        // Fallback to current behavior (cookie-based)
        this.message = this.getMessageByCookie();
      }
    });
  }

  private getMessageByType(errorType: number): string {
    switch (errorType) {
      case ERROR_TYPE.NOT_VALID_PATIENT:
        return "api.errors.patientnotfound";
      case ERROR_TYPE.DEADLINE_EXPIRED:
        return "api.errors.deadlineexpired";
      case ERROR_TYPE.ACCESS_DENIED:
        return "api.errors.ACCESS DENIED";
      case ERROR_TYPE.NOT_VALID_PARAMS:
        return "api.errors.InvalidData";
      case ERROR_TYPE.NOT_VALID_REQUEST:
        return "api.errors.invalidrequest";
      case ERROR_TYPE.EXPIRED_FILE:
        return "api.errors.expiredFile";
      default:
        return "api.errors.unknowerror";
    }
  }

  private getMessageByCookie(): string {
    if (this.cookieService.check(this.COOKIE_NOT_VALID_PATIENT)) {
      this.cookieService.delete(this.COOKIE_NOT_VALID_PATIENT);
      return "api.errors.patientnotfound";
    } else if (this.cookieService.check(this.COOKIE_DEADLINE_EXPIRED)) {
      this.cookieService.delete(this.COOKIE_DEADLINE_EXPIRED);
      return "api.errors.deadlineexpired";
    } else if (this.cookieService.check(this.COOKIE_ACCESS_DENIED)) {
      this.cookieService.delete(this.COOKIE_ACCESS_DENIED);
      return "api.errors.ACCESS DENIED";
    } else if (this.cookieService.check(this.COOKIE_NOT_VALID_PARAMS)) {
      this.cookieService.delete(this.COOKIE_NOT_VALID_PARAMS);
      return "api.errors.InvalidData";
    } else if (this.cookieService.check(this.COOKIE_NOT_VALID_REQUEST)) {
      this.cookieService.delete(this.COOKIE_NOT_VALID_REQUEST);
      return "api.errors.invalidrequest";
    } else if (this.cookieService.check(this.COOKIE_EXPIRED_FILE)) {
      this.cookieService.delete(this.COOKIE_EXPIRED_FILE);
      return "api.errors.expiredFile";
    } else {
      return "api.errors.unknowerror";
    }
  }
}
